/**
 * Module-scoped store for the current OIDC access token.
 *
 * <p>The API client lives outside React (it's plain functions), so it
 * can't call `useAuth()` directly. Instead the AuthProvider tree pushes
 * the latest token into this store on every render, and the client
 * reads from it on each request. That way silent renewals propagate
 * without callers needing to know.</p>
 *
 * <p>Strictly an in-memory mirror of what react-oidc-context already
 * holds — the source of truth stays in the auth context.</p>
 */
let currentToken: string | null = null;

export function setCurrentToken(token: string | null): void {
  currentToken = token;
}

export function getCurrentToken(): string | null {
  return currentToken;
}
